export default {
  computed: {
    requiredFieldsChecklist() {
      return this.getRequiredFieldsConfig()
        .filter((field) => field.isVisible() && this.isFieldShownInChecklist(field))
        .map((field) => ({
          label: this.formatRequiredFieldLabel(field.labelKey),
          isComplete: this.isRequiredFieldComplete(field),
        }));
    },
  },
  methods: {
    formatRequiredFieldLabel(labelKey) {
      return this.$t(labelKey).replace(/\*+$/g, '').trim();
    },
    isNonEmpty(value) {
      return String(value || '').trim().length > 0;
    },
    isFieldShownInChecklist(field) {
      if (!field.prefilledKey) {
        return true;
      }

      return !this.signUpDisabledFields[field.prefilledKey];
    },
    isRequiredFieldComplete(field) {
      if (!field.isFilled()) {
        return false;
      }

      if (field.fieldName && this.errors.has(field.fieldName)) {
        return false;
      }

      return true;
    },
    getRequiredFieldsConfig() {
      const isBorrower = this.userData.role === 'borrower';

      return [
        {
          labelKey: 'message.signUp.mainData.surname.title',
          fieldName: 'surname',
          prefilledKey: 'family_name_ru',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.name_ru.family_name_ru),
        },
        {
          labelKey: 'message.signUp.mainData.name.title',
          fieldName: 'name',
          prefilledKey: 'given_name_ru',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.name_ru.given_name_ru),
        },
        {
          labelKey: 'message.signUp.mainData.birthDate.title',
          prefilledKey: 'birthdate',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.birthdate),
        },
        {
          labelKey: 'message.signUp.mainData.citizenship.title',
          fieldName: 'citizenship',
          prefilledKey: 'citizenship',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.citizenship),
        },
        {
          labelKey: 'message.signUp.mainData.birthPlace.title',
          fieldName: 'birthPlace',
          prefilledKey: 'birth_place_str',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.birth_place_str),
        },
        {
          labelKey: 'message.signUp.idBlock.idIdentification.title',
          fieldName: 'nationalIdNumber',
          prefilledKey: 'national_id_number',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.national_id_number),
        },
        {
          labelKey: 'message.signUp.idBlock.mainDocument.title',
          fieldName: 'mainDocument',
          prefilledKey: 'type',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.id_document.type),
        },
        {
          labelKey: 'message.signUp.idBlock.seriesAndNumber.title',
          fieldName: 'idSeries',
          prefilledKey: 'seriesNumber',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.id_document.seriesNumber),
        },
        {
          labelKey: 'message.signUp.idBlock.idDateIssue.title',
          prefilledKey: 'issueDate',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.id_document.issueDate),
        },
        {
          labelKey: 'message.signUp.idBlock.expireDate.title',
          prefilledKey: 'expireDate',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.id_document.expireDate),
        },
        {
          labelKey: 'message.signUp.idBlock.idIssuedBy.title',
          fieldName: 'idIssuedBy',
          prefilledKey: 'authority',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.id_document.authority),
        },
        {
          labelKey: 'message.signUp.addressBlock.registrationAdress.title',
          fieldName: 'registrationAdress',
          prefilledKey: 'address_str',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.address_str),
        },
        {
          labelKey: 'message.signUp.addressBlock.livingAddress.title',
          isVisible: () => !this.isAddressLivingAndRegistrationTheSame,
          isFilled: () => this.isLivingAddressComplete,
        },
        {
          labelKey: 'message.signUp.jobBlock.typeOfEmployment.title',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.work_info.employment_type),
        },
        {
          labelKey: 'message.signUp.jobBlock.fieldOfEmployment.title',
          isVisible: () => !this.isEmploymentWorkFieldsDisabled,
          isFilled: () => this.isNonEmpty(this.work_info.scope_of_employment_type),
        },
        {
          labelKey: 'message.signUp.jobBlock.nameOfOrganization.title',
          fieldName: 'nameOfOrganization',
          isVisible: () => !this.isEmploymentWorkFieldsDisabled,
          isFilled: () => this.isNonEmpty(this.work_info.organization_name),
        },
        {
          labelKey: 'message.signUp.jobBlock.post.title',
          isVisible: () => !this.isEmploymentWorkFieldsDisabled,
          isFilled: () => this.isNonEmpty(this.work_info.job_position_type),
        },
        {
          labelKey: 'message.signUp.jobBlock.otherPositionType.title',
          fieldName: 'otherPositionType',
          isVisible: () => this.isOtherJobPositionType,
          isFilled: () => this.isNonEmpty(this.work_info.job_position_name),
        },
        {
          labelKey: 'message.signUp.jobBlock.workExperience.title',
          fieldName: 'workExperience',
          isVisible: () => isBorrower && !this.isEmploymentWorkFieldsDisabled,
          isFilled: () => this.isNonEmpty(this.work_info.workExperience),
        },
        {
          labelKey: 'message.signUp.extraBlock.dependensNumber.title',
          fieldName: 'dependensNumber',
          isVisible: () => isBorrower,
          isFilled: () => this.isNonEmpty(this.extra_user_info.dependens_number),
        },
        {
          labelKey: 'message.signUp.extraBlock.totalIncome.title',
          fieldName: 'totalIncome',
          isVisible: () => isBorrower,
          isFilled: () => this.isNonEmpty(this.extra_user_info.total_income),
        },
        {
          labelKey: 'message.signUp.requiredFields.carPassport',
          isVisible: () => isBorrower && this.extra_user_info.car_owner,
          isFilled: () => this.car_passport_files.length >= 2,
        },
        {
          labelKey: 'message.signUp.requiredFields.realEstate',
          isVisible: () => isBorrower && this.extra_user_info.real_estate_owner,
          isFilled: () => this.real_estate_files.length >= 1,
        },
        {
          labelKey: 'message.signUp.basicBlock.keyWord.title',
          fieldName: 'codeword',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.codeword),
        },
        {
          labelKey: 'message.signUp.basicBlock.email.title',
          prefilledKey: 'email',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.email),
        },
        {
          labelKey: 'message.signUp.passwordBlock.password.title',
          fieldName: 'password',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.password),
        },
        {
          labelKey: 'message.signUp.basicBlock.msisdn.title',
          fieldName: 'msisdn',
          prefilledKey: 'phone_number',
          isVisible: () => true,
          isFilled: () => this.isNonEmpty(this.userData.phone_number),
        },
        {
          labelKey: 'message.signUp.basicBlock.otp.title',
          isVisible: () => true,
          isFilled: () => String(this.userData.otp || '').trim().length >= 6,
        },
      ];
    },
  },
};
